/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Viewings_Report_Not_PurchasedInputs */

const cs_viewings_report_not_purchased = /** @type {(inputs: Viewings_Report_Not_PurchasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nekoupil: ${i?.n}`)
};

const en_viewings_report_not_purchased = /** @type {(inputs: Viewings_Report_Not_PurchasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not purchased: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Not purchased: {n}" |
*
* @param {Viewings_Report_Not_PurchasedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_report_not_purchased = /** @type {((inputs: Viewings_Report_Not_PurchasedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Report_Not_PurchasedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_report_not_purchased(inputs)
	return cs_viewings_report_not_purchased(inputs)
});